import { LoanOperationType } from '@enums/loan-operation/loan-operation-type.enum';

/** Nome da modalidade como o cadastro de empréstimos mostra (card 3611). */
const LOAN_OPERATION_TYPE_LABELS: Record<LoanOperationType, string> = {
  [LoanOperationType.ACE]: 'ACE',
  [LoanOperationType.ACC]: 'ACC',
  [LoanOperationType.BNDES]: 'BNDES',
  [LoanOperationType.WORKING_CAPITAL]: 'Capital de Giro',
  [LoanOperationType.MANUFACTURER_FINANCING]: 'CDC Montadora',
  [LoanOperationType.DIRECT_CONSUMER_CREDIT]: 'Crédito Direto ao Consumidor',
  [LoanOperationType.BANK_CREDIT_NOTE]: 'Cédula de Crédito Bancário',
  [LoanOperationType.EXPORT_CREDIT_BALLOT]: 'Cédula de Crédito de Exportação',
  [LoanOperationType.FINIMP]: 'FINIMP',
  [LoanOperationType.LEASING]: 'Leasing',
  [LoanOperationType.LOAN]: 'Mútuo',
  [LoanOperationType.EXPORT_CREDIT_NOTE]: 'Nota de Crédito de Exportação',
  [LoanOperationType.FOREIGN_REPASS]: 'Repasse Externo (4131)',
  [LoanOperationType.EXPORT_PREPAYMENT]: 'Pré-Pagamento de Exportação',
  [LoanOperationType.COMMERCIAL_NOTE]: 'Nota Comercial',
};

/** Rótulo da modalidade; valor desconhecido aparece como veio, para não sumir da linha. */
export function loanOperationTypeLabel(
  type: LoanOperationType | string | null | undefined
): string {
  if (!type) return '–';
  return LOAN_OPERATION_TYPE_LABELS[type as LoanOperationType] ?? type;
}
